import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const WatchtowerRuleListRBAC = {
  pageID: 'dc68201a3f8ba2170c98d683f4ca956b',
  elementID: {
    ViewPage: 'd0b667010b8ec1a3833ff9be0d0333dd',
    CreateRule: '6b83eba4c30b6671d55f03784a972c8d',
    EditRule: '4e5987cc8d8ec1a3349090fcecf2c981',
    UpdateStatus: 'c81df075aef875d172a084f476e83666',
    FilterWatchtower: '0da6c22a6fd6ec2f68a0fdd59fa0c827',
  },
} as const

export const useRBACWatchtowerRuleListPage = createUseRBAC(WatchtowerRuleListRBAC.elementID)
export type UseRBAWatchtowerRuleListPageType = ReturnType<typeof useRBACWatchtowerRuleListPage>

export const WatchtowerAutoCancelRuleListRBAC = {
  pageID: '9950cca3a9e808d9838840b88cf98fc4',
  elementID: {
    ViewPage: '5b95b5b5747880bb11f5af8bf1dc8782',
    CreateRule: 'b5b80bdbcc9f74acfbba20a110b242c2',
    EditRule: '6121b4b8667880bac8a31dfc360a0c42',
    UpdateStatus: 'f5e17adec7839fa585404054a07c634d',
  },
} as const

export const useRBACWatchtowerAutoCancelRuleListPage = createUseRBAC(
  WatchtowerAutoCancelRuleListRBAC.elementID,
)
export type UseRBAWatchtowerAutoCancelRuleListPageType = ReturnType<
  typeof useRBACWatchtowerAutoCancelRuleListPage
>
